import { render, staticRenderFns } from "./footer-links.vue?vue&type=template&id=faaa72ca&scoped=true&"
import script from "./footer-links.vue?vue&type=script&lang=js&"
export * from "./footer-links.vue?vue&type=script&lang=js&"
import style0 from "./footer-links.vue?vue&type=style&index=0&id=faaa72ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faaa72ca",
  null
  
)

export default component.exports